import script from "./InscriptionSignBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionSignBlock.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionSignBlock.vue?vue&type=style&index=0&id=66f7f50f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f7f50f"]])

export default __exports__